export const blockIconsEditorPublish = (
	<span className='material-symbols-outlined'>publish</span>
);
